'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.ProfileChart.Toolbar', dependencies).controller('ProfileChartToolbarController', require('./controllers/ProfileChartToolbarController')).directive('rmProfileChartToolbar', require('./directives/ProfileChartToolbarDirective'));